import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './rootDishCategoryBySlugQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type RootDishCategoryBySlugQuery_rootDishCategoryBySlug_RootDishCategory = {
  __typename: 'RootDishCategory',
  id: number,
  name: string,
  slug: string
};

export type RootDishCategoryBySlugQuery_Query = {
  __typename?: 'Query',
  rootDishCategoryBySlug: RootDishCategoryBySlugQuery_rootDishCategoryBySlug_RootDishCategory
};


export type RootDishCategoryBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type RootDishCategoryBySlugQuery = RootDishCategoryBySlugQuery_Query;


export const RootDishCategoryBySlugDocument = /*#__PURE__*/ document as unknown as DocumentNode<RootDishCategoryBySlugQuery, RootDishCategoryBySlugQueryVariables>;


/**
 * __useRootDishCategoryBySlugQuery__
 *
 * To run a query within a React component, call `useRootDishCategoryBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootDishCategoryBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootDishCategoryBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useRootDishCategoryBySlugQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RootDishCategoryBySlugQuery, RootDishCategoryBySlugQueryVariables> & ({ variables: RootDishCategoryBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RootDishCategoryBySlugQuery, RootDishCategoryBySlugQueryVariables>(RootDishCategoryBySlugDocument, options);
      }
export function useRootDishCategoryBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RootDishCategoryBySlugQuery, RootDishCategoryBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RootDishCategoryBySlugQuery, RootDishCategoryBySlugQueryVariables>(RootDishCategoryBySlugDocument, options);
        }
export function useRootDishCategoryBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RootDishCategoryBySlugQuery, RootDishCategoryBySlugQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RootDishCategoryBySlugQuery, RootDishCategoryBySlugQueryVariables>(RootDishCategoryBySlugDocument, options);
        }
export type RootDishCategoryBySlugQueryHookResult = ReturnType<typeof useRootDishCategoryBySlugQuery>;
export type RootDishCategoryBySlugLazyQueryHookResult = ReturnType<typeof useRootDishCategoryBySlugLazyQuery>;
export type RootDishCategoryBySlugSuspenseQueryHookResult = ReturnType<typeof useRootDishCategoryBySlugSuspenseQuery>;
export type RootDishCategoryBySlugQueryResult = ApolloReactCommon.QueryResult<RootDishCategoryBySlugQuery, RootDishCategoryBySlugQueryVariables>;